const authorityAssetUrls = new Map();

export function rememberAuthorityAssetUrl(url, assetId) {
  if (typeof url !== "string" || typeof assetId !== "string") return;
  authorityAssetUrls.set(url, assetId);
  if (authorityAssetUrls.size > 500) {
    authorityAssetUrls.delete(authorityAssetUrls.keys().next().value);
  }
}

export function assetIdForAuthorityUrl(url) {
  return authorityAssetUrls.get(url) || null;
}
